import React from "react";
import {
  ContactUs,
  Experience,
  Home,
  Layout,
  Projects,
  Skills,
  Teams,
} from "../components";

const Main = () => {
  return (
    <Layout>
      <Home />
      <Experience />
      <Skills />
      <Projects />
      <Teams />
      <ContactUs />
    </Layout>
  );
};

export default Main;
